
const state = () => ({

  _callstack: [],

  screed: { values: [] },

  insulation: { values: [] },

  underfloorHeating: { values: [] },

  fill: { values: [] },

  soundInsulation: { values: [] },

  woodenPanel: { values: [] },

  supportingStructure: { values: [] },

  suspendedCeiling: { values: [] },

  impactSoundLevel: { values: [] },

  soundReductionIndex: { values: [] },

  heatTransferCoefficient: { values: [] },

  fireResistance: { values: [] }

})

export default state
